export const FEE_PAYMENT_MODE_LABELS = {
  cash: 'Cash',
  upi: 'UPI',
  bank_transfer: 'Bank Transfer',
  cheque: 'Cheque',
  dd: 'Demand Draft',
  card: 'Card',
  netbanking: 'Net Banking',
  wallet: 'Wallet',
  emi: 'EMI',
  other: 'Other',
}

export const FEE_PAYMENT_STATUS_LABELS = {
  completed: 'Completed',
  reversed: 'Reversed',
}

export const getFeePaymentModeLabel = (paymentMode) => {
  const normalized = String(paymentMode || '').trim().toLowerCase()
  if (!normalized) return 'Unknown'
  return FEE_PAYMENT_MODE_LABELS[normalized] || normalized.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}

export const getFeePaymentStatusLabel = (status) => {
  const normalized = String(status || '').trim().toLowerCase()
  if (!normalized) return 'Completed'
  return FEE_PAYMENT_STATUS_LABELS[normalized] || normalized.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}

export const isManualPaymentReferenceRequired = (paymentMode) =>
  String(paymentMode || '').trim().toLowerCase() !== 'cash'

export const formatCurrency = (value = 0) => `₹${Number(value || 0).toLocaleString('en-IN')}`

export const formatDate = (value) =>
  value
    ? new Intl.DateTimeFormat('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      }).format(new Date(value))
    : '—'
